import { Box, Stack } from "@mui/material";
import { Illustration, Text, Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { SlideTextContainer } from "../../components/SlideTextContainer";

function InstantPayCard() {
  return (
    <Box
      sx={{
        width: 270,
        height: 388,
        backgroundColor: "background.tertiary",
        borderRadius: "37.565px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "52.56px",
        paddingLeft: "11.52px",
        paddingRight: "11.52px",
      }}
    >
      <Stack spacing="23.04px" alignItems="center" sx={{ width: 247 }}>
        <Illustration type="instant-pay-small" sx={{ width: 72, height: 72 }} />

        <Stack spacing="17.28px" alignItems="center">
          <Text
            sx={{
              fontSize: "23.04px",
              fontWeight: 400,
              lineHeight: "28.8px",
              letterSpacing: "-0.2304px",
              color: "text.primary",
              textAlign: "center",
            }}
          >
            Congrats, you&apos;ve been instantly paid!
          </Text>
          <Text
            sx={{
              fontSize: "11.52px",
              fontWeight: 400,
              lineHeight: "13.8px",
              letterSpacing: "-0.1152px",
              color: "text.secondary",
              textAlign: "center",
              width: 201,
            }}
          >
            You have clocked out of your shift and we just processed your payment to your Stripe
            account.
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
}

export function InstantPaySlide() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 58,
          position: "relative",
          overflow: "hidden",
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: 388,
            "@media (max-height: 740px)": { zoom: 0.85 },
            "@media (max-height: 670px)": { zoom: 0.75 },
          }}
        >
          <InstantPayCard />
        </Box>
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "50%",
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            background: `linear-gradient(to bottom, transparent 0%, transparent 36%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 75%)`,
            pointerEvents: "none",
          })}
        />
      </Box>

      <SlideTextContainer>
        <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
          <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
            Link your bank account
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            to get paid instantly
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            after every shift
          </Title>
        </Stack>
      </SlideTextContainer>
    </Box>
  );
}
